type sessionStorageDividendProps = {
  depositType?: number;
  depositPeriod?: number;
  depositChart?: number;
  predictionType?: number;
  predictionPeriod?: number;
};

export const getDividendStorage = (): sessionStorageDividendProps | null => {
  const dividendJson = sessionStorage.getItem('dividend');
  return dividendJson
    ? (JSON.parse(dividendJson) as sessionStorageDividendProps)
    : null;
};

export const setDividendStorage = (list: sessionStorageDividendProps) => {
  sessionStorage.setItem('dividend', JSON.stringify(list));
};
